<template>
  <div>
    <Breadcrumb
      :search_route="`/store/show/${$route.params.id}/mealAdd`"
      search_title="إضافه وجبة"
      icon="fa-plus"
    />
    <div class="mb-2">
      <span>اجمالي عدد الوجبات : ({{ totalMeals }})</span>
    </div>
    <v-btn
      @click="dragShow = true"
      class="btn-reorder-trigger mb-2"
      dark
      elevation="2"
    >
      <i class="fal fa-sort-amount-down ml-2"></i>
      ترتيب المنيو
    </v-btn>
    <v-tabs dark background-color="#783d73" v-model="tab">
      <v-tab
        v-for="(item, index) in meals"
        :key="index"
        @click="getData(item.id)"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <main>
      <v-data-table
        class="thumb strip"
        :headers="headers"
        :items="rows"
        :loading-text="$t('table.loadingData')"
        item-key="id"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Image -->
        <template v-slot:[`item.image`]="{ item }">
          <img @click="show_model_1" class="image" :src="item.image" />
        </template>

        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <span>{{ item.is_active == 1 ? "مُفعل" : "غير مُفعل" }}</span>
        </template>

        <template v-slot:[`item.is_ban`]="{ item }">
          <v-btn
            @click="toggleStatusModel(item)"
            :color="item.is_ban ? 'error' : 'success'"
            >{{ item.is_ban ? "محظور" : "غير محظور" }}</v-btn
          >
        </template>
        <!-- <template v-slot:[`item.fullname`]="{ item }">
            <span v-if="!item.fullname || item.fullname == ''">لا يوجد</span>
            <span>{{ item.fullname }}</span>
          </template> -->
        <!-- <template v-slot:[`item.phone`]="{ item }">
            <span v-if="!item.phone || item.phone == ''">لا يوجد</span>
            <span>{{ item.phone_code + item.phone }}</span>
          </template> -->
        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
            <v-icon class="edit" small @click="editItem(item)">
              fal fa-edit
            </v-icon>
            <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon>
          </div>
        </template>

        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <h3 class="table-title title">
            الوجبات
            <span class="total">({{ totalMenuItems }})</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  far fa-info-circle
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </h3>
          <!-- Delete dialog -->
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{ $t("table.deletedialog.areYouSure") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm">
                  {{ $t("table.deletedialog.ok") }}
                </v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">
                  {{ $t("table.deletedialog.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Add & Delete -->
          <v-row>
            <v-col cols="12" sm="8"></v-col>
          </v-row>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!-- Start Pagination -->
    <template>
      <div
        class="pagination_container text-center mb-5 d-flex justify-content-end"
      >
        <v-pagination
          color="primary"
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="5"
          @input="fetchData($event)"
        ></v-pagination>
      </div>
    </template>
    <!-- End Pagination -->
    <!--Dialog For Edit Ordering-->
    <v-dialog
      v-model="dragShow"
      max-width="580px"
      content-class="creative-reorder-modal"
      transition="dialog-transition"
    >
      <div class="reorder-card">
        <!-- Top luminous gradient bar -->
        <div class="reorder-top-glow"></div>

        <!-- Dialog Header -->
        <div class="reorder-header">
          <div class="reorder-header-info">
            <div class="header-icon-wrapper">
              <i class="fal fa-sort-amount-down-alt"></i>
            </div>
            <div class="header-text-group">
              <div class="title-with-badge">
                <h4 class="reorder-title">ترتيب أقسام المنيو</h4>
                <span class="reorder-count-chip" v-if="meals && meals.length">
                  {{ meals.length }} أقسام
                </span>
              </div>
              <p class="reorder-subtitle">
                اسحب الأقسام وأفلتها لتحديد ترتيب ظهورها للعملاء في القائمة
              </p>
            </div>
          </div>
          <button
            type="button"
            class="reorder-close-btn"
            @click="dragShow = false"
            title="إغلاق النافذة"
          >
            <i class="fal fa-times"></i>
          </button>
        </div>

        <!-- Interactive Hint Strip -->
        <div class="reorder-hint-strip">
          <div class="hint-icon-box">
            <i class="fal fa-hand-pointer"></i>
          </div>
          <span>اضغط مع السحب على أي قسم لإعادة ترتيب الأولويات فورياً</span>
        </div>

        <!-- Draggable Categories List -->
        <div class="reorder-body">
          <draggable
            v-if="meals && meals.length"
            v-model="meals"
            class="reorder-items-stack"
            :animation="220"
            ghost-class="sort-ghost"
            chosen-class="sort-chosen"
            drag-class="sort-drag"
            handle=".reorder-item-row"
          >
            <div
              v-for="(item, index) in meals"
              :key="item.id"
              class="reorder-item-row"
            >
              <!-- Drag Grip Indicator -->
              <div class="item-grip" title="اسحب للترتيب">
                <i class="fal fa-grip-vertical"></i>
              </div>

              <!-- Priority Position Badge -->
              <div class="item-rank-badge">
                <span class="rank-hash">#</span>
                <span class="rank-num">{{ index + 1 }}</span>
              </div>

              <!-- Category Icon -->
              <div class="item-cat-icon">
                <i class="fal fa-utensils-alt"></i>
              </div>

              <!-- Category Title -->
              <div class="item-name-col">
                <span class="item-name">{{ item.name }}</span>
              </div>

              <!-- Reorder Direction Hint -->
              <div class="item-drag-pill">
                <i class="fal fa-arrows-alt-v"></i>
              </div>
            </div>
          </draggable>

          <!-- Empty State -->
          <div v-else class="reorder-empty-state">
            <div class="empty-icon-wrap">
              <i class="fal fa-folder-open"></i>
            </div>
            <h5>لا توجد أقسام منيو</h5>
            <p>لم يتم العثور على أي أقسام منيو في هذا المتجر حتى الآن</p>
          </div>
        </div>

        <!-- Dialog Action Footer -->
        <div class="reorder-footer">
          <div class="footer-left-side">
            <button
              type="button"
              class="reorder-btn-restore"
              @click="getMeals"
              title="إعادة الترتيب المحفوظ مسبقاً"
              :disabled="btnIsLoading"
            >
              <i class="fal fa-undo-alt ml-1"></i>
              <span>استعادة الأصلي</span>
            </button>
          </div>

          <div class="footer-right-side">
            <v-btn
              class="reorder-btn-cancel"
              depressed
              @click="dragShow = false"
              :disabled="btnIsLoading"
            >
              <i class="fal fa-times ml-1"></i>
              إلغاء
            </v-btn>

            <v-btn
              class="reorder-btn-save"
              depressed
              :loading="btnIsLoading"
              :disabled="btnIsLoading || !meals || meals.length === 0"
              @click="saveOrder"
            >
              <i class="fal fa-check-circle ml-1"></i>
              حفظ الترتيب
            </v-btn>
          </div>
        </div>
      </div>
    </v-dialog>
    <!--Dialog For Edit Ordering-->

    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  props: ["id"],

  components: {
    draggable,
  },

  data() {
    return {
      btnIsLoading: false,
      data: {
        userInfo: null,
        loading: false,
        // ========== Data To Send
        image_preview: null,
        avatar: null,
      },
      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      meals: [],
      rows: [],
      tab: null,
      totalMenuItems: null,
      // ========== Main Loader
      loaderPage: false,
      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      dragShow: false,
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
      totalMeals: null,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: false,
          },
          {
            text: "الصورة",
            align: "center",
            value: "image",
            sortable: false,
          },
          {
            text: "الاسم",
            value: "name",
            align: "center",
            sortable: false,
          },
          {
            text: "الوصف",
            value: "desc",
            align: "center",
            sortable: false,
          },
          {
            text: "مفعل؟",
            value: "is_active",
            align: "center",
            sortable: false,
          },
          {
            text: "تاريخ الإنشاء ",
            value: "created_at",
            align: "center",
            sortable: false,
          },
          // {
          //   text: "الدولة",
          //   value: "country.name",
          //   align: "center",
          // },
          // {
          //   text: "حالة الحظر",
          //   value: "is_ban",
          //   align: "center",
          // },
          {
            text: "التحكم",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: false,
          },
          {
            text: "image",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Name", value: "fullname", align: "center" },
          { text: "Followers", value: "followers_count", align: "center" },
          { text: "Following", value: "followings_count", align: "center" },
          {
            text: "Active",
            value: "is_active",
            align: "center",
          },
          {
            text: "Permission",
            value: "role",
            align: "center",
          },
          {
            text: "control",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
    keyword() {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword;
      } else {
        return "";
      }
    },
  },
  methods: {
    getMeals() {
      this.data.loading = true;
      this.$axios({
        method: "GET",
        url: `store/${this.$route.params.id}/menus`,
      })
        .then((res) => {
          this.meals = res.data.data;
          this.totalMeals = res.data.meals_count;
          this.getData(this.meals[0].id);
          this.data.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },
    getData(id) {
      this.data.loading = true;
      this.$axios({
        method: "GET",
        url: `store/${this.$route.params.id}/meals`,
        params: {
          page: this.paginations.current_page,
          menu_id: id,
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.rows = res.data.data;
          this.totalMenuItems = res.data.meta.total;

          this.data.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.data.loading = false;
        });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.avatar = obj;
      this.submitData();
    },

    fetchData(e) {
      this.$router.replace({ query: { ...this.$route.query, pageNum: e } });
      this.getData();
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    showItem(item) {
      this.$router.push({
        path: `/googlePlace/${this.$route.params.id}/show/${item.id}`,
      });
    },
    editItem(item) {
      this.$router.push({
        path: `/store/show/${this.$route.params.id}/mealEdit/${item.id}`,
      });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `delete_multi_google_meals/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    submitData() {
      const submit_data = new FormData();
      if (this.data.avatar) {
        submit_data.append("image", this.data.avatar);
      }

      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `place/${this.id}/update_image`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/googlePlace/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    saveOrder() {
      this.btnIsLoading = true;
      const storeId = this.$route.params.id || this.id;
      const submit_data = new FormData();
      this.meals.forEach((item, index) => {
        submit_data.append(`priorities[${index}][menu_id]`, item.id);
        submit_data.append(`priorities[${index}][priority]`, index + 1);
      });
      this.$axios({
        method: "POST",
        url: `store/${storeId}/menus/ordering`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.btnIsLoading = false;
          this.dragShow = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  watch: {
    [`$route`]() {
      if (this.$route.query.pageNum) {
        this.paginations.current_page = +this.$route.query.pageNum;
        this.getData();
      } else {
        this.paginations.current_page = 1;
        this.getData();
      }
    },
  },

  created() {
    if (this.$route.query.pageNum) {
      this.paginations.current_page = +this.$route.query.pageNum;
    }
    this.getMeals();
    // if (this.meals.length > 0) {
    //   this.getData(this.meals[0].id);
    // }
  },
};
</script>

<style lang="scss">
.avatar_wrapper {
  overflow: hidden;
}
// Custom trigger button
.btn-reorder-trigger {
  background: linear-gradient(135deg, #783d73 0%, #9c3f94 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 14px rgba(120, 61, 115, 0.28) !important;
  transition: all 0.25s ease !important;
  letter-spacing: 0 !important;

  &:hover {
    box-shadow: 0 6px 20px rgba(120, 61, 115, 0.42) !important;
    transform: translateY(-1px);
  }
}

// Vuetify Dialog Container Override
.v-dialog.creative-reorder-modal {
  border-radius: 20px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 50px -12px rgba(120, 61, 115, 0.25),
    0 0 0 1px rgba(120, 61, 115, 0.08) !important;
}

// Main Card inside Dialog
.reorder-card {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  font-family: inherit;
}

// Top Glowing Ribbon
.reorder-top-glow {
  height: 5px;
  width: 100%;
  background: linear-gradient(90deg, #783d73 0%, #c846e3 50%, #f472b6 100%);
}

// Header
.reorder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;

  .reorder-header-info {
    display: flex;
    align-items: center;
    gap: 14px;

    .header-icon-wrapper {
      width: 46px;
      height: 46px;
      border-radius: 14px;
      background: linear-gradient(
        135deg,
        rgba(120, 61, 115, 0.1) 0%,
        rgba(200, 70, 227, 0.16) 100%
      );
      display: flex;
      align-items: center;
      justify-content: center;
      color: #783d73;
      font-size: 20px;
      flex-shrink: 0;
    }

    .header-text-group {
      .title-with-badge {
        display: flex;
        align-items: center;
        gap: 10px;

        .reorder-title {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          color: #1e293b;
          line-height: 1.3;
        }

        .reorder-count-chip {
          display: inline-flex;
          align-items: center;
          padding: 2px 10px;
          border-radius: 20px;
          background: #f5e8f5;
          color: #783d73;
          font-size: 12px;
          font-weight: 700;
        }
      }

      .reorder-subtitle {
        margin: 4px 0 0;
        font-size: 13px;
        color: #64748b;
        font-weight: 500;
      }
    }
  }

  .reorder-close-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: none;
    background: #f8fafc;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
      background: #fee2e2;
      color: #ef4444;
      transform: rotate(90deg);
    }
  }
}

// Hint Strip
.reorder-hint-strip {
  margin: 14px 24px 6px;
  padding: 10px 14px;
  border-radius: 12px;
  background: linear-gradient(135deg, #faf5ff 0%, #fdf4ff 100%);
  border: 1px dashed rgba(120, 61, 115, 0.22);
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #783d73;
  font-weight: 500;

  .hint-icon-box {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: rgba(120, 61, 115, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #783d73;
    font-size: 12px;
    flex-shrink: 0;
  }
}

// Body / List
.reorder-body {
  padding: 10px 24px 16px;
  max-height: 380px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f8fafc;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
    &:hover {
      background: #94a3b8;
    }
  }
}

.reorder-items-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// Draggable Item Card
.reorder-item-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1.5px solid #edf2f7;
  border-radius: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
  cursor: grab;
  user-select: none;
  position: relative;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: #c084fc;
    box-shadow: 0 8px 20px -4px rgba(120, 61, 115, 0.15);
    transform: translateY(-2px);

    .item-grip {
      color: #783d73;
    }
    .item-drag-pill {
      opacity: 1;
      color: #783d73;
      background: #f5e8f5;
    }
  }

  .item-grip {
    color: #cbd5e1;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
    flex-shrink: 0;
  }

  .item-rank-badge {
    min-width: 32px;
    height: 32px;
    border-radius: 9px;
    background: linear-gradient(
      135deg,
      rgba(120, 61, 115, 0.08) 0%,
      rgba(168, 85, 247, 0.12) 100%
    );
    border: 1px solid rgba(120, 61, 115, 0.15);
    color: #783d73;
    font-weight: 700;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .rank-hash {
      font-size: 11px;
      opacity: 0.7;
      margin-left: 1px;
    }
    .rank-num {
      font-size: 13px;
    }
  }

  .item-cat-icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #f8fafc;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .item-name-col {
    flex: 1;
    min-width: 0;

    .item-name {
      font-size: 15px;
      font-weight: 600;
      color: #1e293b;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .item-drag-pill {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: transparent;
    color: #cbd5e1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    opacity: 0.6;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }
}

// Drag States
.sort-chosen {
  border-color: #783d73 !important;
  background: #fdfaff !important;
  box-shadow: 0 14px 28px rgba(120, 61, 115, 0.22) !important;
  transform: scale(1.02) !important;
  z-index: 999 !important;
}

.sort-ghost {
  opacity: 0.35 !important;
  border: 2px dashed #783d73 !important;
  background: rgba(120, 61, 115, 0.06) !important;
  box-shadow: none !important;
  transform: scale(0.99) !important;
}

.sort-drag {
  cursor: grabbing !important;
}

// Empty State
.reorder-empty-state {
  text-align: center;
  padding: 30px 20px;

  .empty-icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 16px;
    background: #f8fafc;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    margin: 0 auto 12px;
  }

  h5 {
    font-size: 16px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 4px;
  }

  p {
    font-size: 13px;
    color: #94a3b8;
    margin: 0;
  }
}

// Footer
.reorder-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 20px;
  background: #fcfcfd;
  border-top: 1px solid #f1f5f9;

  .footer-left-side {
    .reorder-btn-restore {
      border: none;
      background: transparent;
      color: #64748b;
      font-size: 12.5px;
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 6px 12px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover:not(:disabled) {
        background: #f1f5f9;
        color: #783d73;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  .footer-right-side {
    display: flex;
    align-items: center;
    gap: 10px;

    .reorder-btn-cancel {
      height: 42px !important;
      border-radius: 11px !important;
      border: 1.5px solid #e2e8f0 !important;
      background: #ffffff !important;
      color: #64748b !important;
      font-weight: 600 !important;
      font-size: 14px !important;
      padding: 0 20px !important;
      text-transform: none !important;
      letter-spacing: 0 !important;
      transition: all 0.2s ease !important;

      &:hover:not(:disabled) {
        border-color: #fca5a5 !important;
        background: #fef2f2 !important;
        color: #ef4444 !important;
      }
    }

    .reorder-btn-save {
      height: 42px !important;
      border-radius: 11px !important;
      background: linear-gradient(135deg, #783d73 0%, #90428a 100%) !important;
      color: #ffffff !important;
      font-weight: 600 !important;
      font-size: 14px !important;
      padding: 0 24px !important;
      text-transform: none !important;
      letter-spacing: 0 !important;
      box-shadow: 0 6px 16px rgba(120, 61, 115, 0.3) !important;
      transition: all 0.25s ease !important;

      &:hover:not(:disabled) {
        box-shadow: 0 8px 22px rgba(120, 61, 115, 0.45) !important;
        transform: translateY(-1px);
      }
    }
  }
}
</style>
